
import { Link } from 'react-router-dom';
import NavBar from '../../components/feature/NavBar';
import About from '../home/components/About';
import WhyChoose from '../home/components/WhyChoose';
import SEOHead from '../../components/feature/SEOHead';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://zjfitservices.com';

const aboutJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'About ZJF IT Services LLC | NYC IT Deployment Specialists',
    description: 'Learn about ZJF IT Services LLC — a New York-based IT deployment company serving MSPs and enterprises nationwide with disciplined field execution and operational readiness.',
    url: `${siteUrl}/about`,
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
        { '@type': 'ListItem', position: 2, name: 'About', item: `${siteUrl}/about` },
      ],
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'ZJF IT Services LLC',
    url: siteUrl,
    logo: 'https://public.files.download.flockmail.com/6581760/2690761113950208_1',
    description: 'NYC-based IT deployment specialists serving MSPs and enterprises nationwide with workstation rollouts, structured cabling, and network installations.',
    telephone: '+19737504968',
    email: 'info@zjfitservices.com',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'New York',
      addressRegion: 'NY',
      addressCountry: 'US',
    },
    areaServed: ['New York', 'United States'],
  },
];

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-zinc-950">
      <SEOHead
        title="About ZJF IT Services LLC | NYC IT Deployment Specialists"
        description="Learn about ZJF IT Services LLC — a New York-based IT deployment company serving MSPs and enterprises nationwide with disciplined field execution and operational readiness."
        keywords="about ZJF IT Services, NYC IT deployment company, IT specialists New York, MSP field services, enterprise IT support"
        canonical={`${siteUrl}/about`}
        jsonLd={aboutJsonLd}
      />
      <NavBar />
      <div className="pt-20">
        <div className="py-16 bg-zinc-950 text-center border-b border-zinc-800">
          <span className="text-orange-500 text-sm font-semibold uppercase tracking-widest mb-3 block">Who We Are</span>
          <h1 className="text-5xl font-bold text-white mb-4">About ZJF IT Services</h1>
          <p className="text-zinc-400 text-lg max-w-2xl mx-auto">
            NYC-based IT deployment specialists serving MSPs and enterprises nationwide.
          </p>
        </div>
        <About />
        <WhyChoose />
        <div className="py-16 bg-zinc-950 text-center">
          <Link
            to="/contact"
            className="bg-orange-500 hover:bg-orange-600 text-white px-10 py-4 rounded-md text-base font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer inline-block"
          >
            Get in Touch
          </Link>
        </div>
      </div>
    </div>
  );
}
